import TrackMenu from '../components/partials/ProductTabs/TrackMenu/TrackMenu';
import { durationFormat } from '@/components/common/Grid/GridUtilities';
import { TranslatableColDef } from '@/components/common/Grid/TranslatableColDef';

export const trackListColDef: TranslatableColDef[] = [
  {
    field: 'id',
    headerName: 'id',
    hide: true,
    width: 0,
  },
  {
    field: 'trackNumber',
    headerName: '#',
    hide: false,
    width: 70,
  },
  {
    field: 'title',
    headerName: 'Title',
    headerNameTranslationKey: 'track.trackTitle',
    resizable: false,
    suppressColumnsToolPanel: false,
    flex: 1,
  },

  {
    field: 'version',
    headerName: 'Version',
    headerNameTranslationKey: 'track.version',
    resizable: false,
    suppressColumnsToolPanel: false,
    flex: 1,
  },
  {
    field: 'displayArtist',
    headerName: 'Display Artist',
    headerNameTranslationKey: 'track.displayArtist',
    resizable: false,
    suppressColumnsToolPanel: false,
    flex: 1,
  },
  {
    field: 'isrc',
    headerName: 'ISRC',
    headerNameTranslationKey: 'track.isrc',
    resizable: false,
    suppressColumnsToolPanel: false,
    flex: 1,
  },
  {
    field: 'duration',
    headerComponentParams: {
      template:
        '<div class="icon-header-cell"><i class="far fa-clock fa-lg"></i></div>',
    },
    headerTooltip: 'Track Length',
    resizable: false,
    suppressColumnsToolPanel: false,
    valueFormatter: durationFormat,
    width: 90,
  },
  {
    width: 40,
    headerName: ' ',
    field: 'action',
    cellRenderer: TrackMenu,
    cellClass: 'action-menu-cell',
  },
];
